// AZURE AD ENVIRONMENT VARIABLES
import Cookies from "js-cookie";

export const azureAdUrlMainDomain = "login.hayya.qa";
export const azureAdUrlDomain = "q22appprod";
export const azureAdClientId = "c35b67f3-d6ee-4af1-85e1-374777e679d6";
export const azureAdSignInPolicy = "B2C_1_portal_signin_signup";
export const apiEndpoint = "https://media-api.hayya.qa/api/v2";
export const moiSubmitApi = true;
export const frontUrl = "https://media-sc.hayya.qa"
export const forgotPasswordCode = 'AADB2C90118';
export const forgotPasswordUri = `https://${azureAdUrlDomain}.b2clogin.com/`
    + `${azureAdUrlDomain}.onmicrosoft.com/`
    + 'B2C_1_portal_password_reset/'
    + 'oauth2/v2.0/authorize?'
    + `client_id=${azureAdClientId}&`
    + `redirect_uri=${frontUrl}/`
    + 'getToken&response_type=id_token&scope=openid';

export const defaultAccreditationTypeCode = 'AACQ2';

export const allowedEmails = ["m.naseeb@sc.qa", "m.naseeb@hayya.qa", "maaz@microsysx.com", "talha@microsysx.com", "t.zafar@hayya.qa", "akhan@hayya.qa","utariq@hayya.qa", "wahmed@hayya.qa"];
export const isEmailAllowed = allowedEmails.includes(Cookies.get('vmc-email'));
export const VERIFICATION_TYPES = {
    APPLICATION_VERIFICATION_SUBMISSION: '1',
    APPLICATION_USER_INVITE_SUBMISSION: '2',
    APPLICATION_VERIFICATION_SUBMISSION_LNG: '3',
};
//